import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const haulApprovalStatusesAdapter = getAdapter({ idFieldName: 'value' });

const haulApprovalStatusesSlice = createSlice({
  name: 'haulApprovalStatuses',
  initialState: haulApprovalStatusesAdapter.getInitialState(),
  reducers: {
    setHaulApprovalStatuses: (state, { payload: { haulApprovalStatuses } }) => {
      haulApprovalStatusesAdapter.setAll(state, haulApprovalStatuses);
    },
  },
});

const selectors = haulApprovalStatusesAdapter.getSelectors(({ haulApprovalStatuses }) => haulApprovalStatuses);

export const getHaulApprovalStatuses = (state) => selectors.selectAll(state);

export const {
  setHaulApprovalStatuses,
} = haulApprovalStatusesSlice.actions;

export default haulApprovalStatusesSlice.reducer;
